module.exports = __webpack_public_path__ + "img/shanghai.10d23897.jpg";